export const deviceSize = {
  slinky: 0,
  slonk: 400,
  sm: 576,
  md: 992,
  // lg has been removed and replaced by md, there was too many things to test with different css for md and lg
  xl: 1200,
  xxl: 1400,
  chonk: 1600,
};

export const size = {
  slinky: `${deviceSize.slinky}px`,
  slonk: `${deviceSize.slonk}px`,
  sm: `${deviceSize.sm}px`,
  md: `${deviceSize.md}px`,
  xl: `${deviceSize.xl}px`,
  xxl: `${deviceSize.xxl}px`,
  chonk: `${deviceSize.chonk}px`,
};

export const device = {
  slinky: `(min-width: ${size.slinky})`,
  slonk: `(min-width: ${size.slonk})`,
  sm: `(min-width: ${size.sm})`,
  md: `(min-width: ${size.md})`,
  xl: `(min-width: ${size.xl})`,
  xxl: `(min-width: ${size.xxl})`,
  chonk: `(min-width: ${size.chonk})`,
};

export const deviceMaxWidth = {
  slinky: `(max-width: ${size.slinky})`,
  slonk: `(max-width: ${size.slonk})`,
  sm: `(max-width: ${size.sm})`,
  md: `(max-width: ${size.md})`,
  xl: `(max-width: ${size.xl})`,
  xxl: `(max-width: ${size.xxl})`,
  chonk: `(max-width: ${size.chonk})`,
};
